import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import CollectionManagementSection from './CollectionManagementSection';
import {saveResourceFieldAction} from "../../resources/actions";
import {extractResourceIdsWithPath, getBreakResource} from "../../utils/DBUtils";
import catchErrors from "../../hoc/catchErrors";
import blockParentUpdates from "../../hoc/blockParentUpdates";

const mapStateToProps = (state, ownProps) => {
  // const masterBreakId = dotProp.get(state.editBreak, 'break.MASTER', null);
  const { savingDisplayOrder } = state.editBreak;

  let masterBreakId = state.editBreak.break.MASTER;
  let masterBreak = state.resources.resources[masterBreakId];

  // let resourceId = ownProps.formProxy.baseResource[ownProps.currentPlatform].resourceId.id;
  // let fieldPath = ownProps.fieldPath.join('.');
  let collection = getBreakResource(masterBreak, masterBreak, ownProps.fieldPath) || [];

  if (!masterBreakId) {
    return {
      savingDisplayOrder,
      collection
    };
  } else {
    return {
      savingDisplayOrder,
      collection
    };
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  startDisplayOrderSave: (resourceId, breakId, resourcePath, fieldPath, orderField, newOrder, resourceIds) => {
    return saveResourceFieldAction(
        resourceId,
        breakId,
        resourcePath,
        fieldPath,
        orderField,
        newOrder,
        resourceIds,
        [],
        [],
        false
    )
  }
}, dispatch);

export default compose(
  blockParentUpdates,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    saveDisplayOrder: props => ({ newOrder, orderField }) => {
      // console.log(newOrder);

      const resourceIds = extractResourceIdsWithPath(
        props.formProxy.baseResource["MASTER"],
        props.formProxy.currentBaseResource,
        props.formProxy.resourcePath
      );

      // Remove end which will be the collection itself
        let resourcePath = props.formProxy.resourcePath.slice(0, props.formProxy.resourcePath.length - 1);
        // Remove the end and add on the actual field we will be sending to api
        let fieldPath = props.formProxy.fieldPath.slice(0, props.formProxy.fieldPath.length - 1).concat(orderField);

        // using parent resource because it will be the object that owns the collection
      props.startDisplayOrderSave(
          props.formProxy.parentCurrentResource.resourceId,
          props.formProxy.currentBaseResource.resourceId,
          resourcePath,
          fieldPath,
          orderField,
          newOrder,
          resourceIds
      );
    }
  }),
  catchErrors
)(CollectionManagementSection);



// WEBPACK FOOTER //
// ./public/components/forms/CollectionManagementSectionContainer.js